import { combineReducers } from 'redux';
// import { loadingBarReducer } from 'react-redux-loading-bar'

import appReducer from './reducers';

export default combineReducers({
  appState: appReducer
});